export default {
    CREATE_INTERNAL_NOTES: () => `/internalNote`,
    GET_INTERNAL_NOTES: (query) => `/internalNote/getByTaskId/${query}`,
    UPDATE_INTERNAL_NOTES: (id) => `/internalNote/${id}`,
    DELETE_INTERNAL_NOTES: (id) => `/internalNote/${id}`,
    GET_ALL_INTERNAL_NOTES: () => `/internalNote`,
};
